export enum StorageFolder {

    user = 'user',
    customer = 'customer',
    metalsCustomer = 'metals-customer',
    vendor = 'vendor',
    metalsVendor = 'metals-vendor',
    product = 'product',
    injectionMoldingProduct = 'injection-molding-product',
    injectionMoldingQualityAlerts = 'injection-molding-quality-alerts',
    plasticsMaterial = 'plastics-material',
    injectionMoldingMaterial = 'injection-molding-material',
    injectionMoldingMold = 'injection-molding-mold',
    plasticsScrap = 'plastics-scrap',
    vendorHardwareData = 'vendor-hardware-data',
    contact = 'contact',
    hardwareItem = 'hardware-item',
    injectionMoldingHardwareItem = 'injection-molding-hardware-item',
    metalsHardwareItem = 'metals-hardware-item',
    metalsWorkOrder = 'metals-work-order',
    robotProgram = 'robot-program',
    plasticsFixture = 'plastics-fixture',
    plasticsOrder = 'plastics-order',
    plasticsShipment = 'plastics-shipment',
    trendsData = 'trends-data',
    prismGeneral = 'prism-general',
    plasticsResource = 'plastics-resource',
    prismResource = 'prism-resource',
    metaltrackJob = 'metaltrack-job',
    metalsCuttingTask = 'metals-cutting-task',
    metalsProject = 'metals-project',
    metalsProduct = 'metals-product',
    metalsQuote = 'metals-quote',
    sheetMetalDxfDocument = 'sheet-metal-dxf-document',
    procedure = 'procedure',
    procedureInstance = 'procedure-instance',
    procedureRedline = 'procedure-redline',
    task = 'task',
    asset = 'asset',
    meeting = 'meeting',
    audio = 'audio',
    transcript = 'transcript',
    softwareTasks = 'software-tasks',
    plasticsProductsQualityAlerts = 'plastics-products-quality-alerts',
    freightCarriers = 'freight-carriers',
    automationHardwareItem = 'automation-hardware-item',
    cribbageGames = 'cribbage-games',
    engineeringUpdateMeeting = 'engineeringUpdateMeeting',
    purchasing = 'purchasing',
    knowledgeDocument = 'knowledge-document',
    complaintLog = 'complaint-log',
    qualityAlerts = 'quality-alerts',
    qualityInspections = 'quality-inspections',
    plasticsSkid = 'plastics-skid',
    softwareRequests = 'software-requests',
    assetHistoryEvents = 'asset-history-events',
    dockInspections = 'dock-inspections',
    maintenance = 'maintenance',
    smartJeffProject = 'smart-jeff-project',
    commonProject = 'common-project',
    plasticsMold = 'plastics-mold',
    plasticsMoldHistoryEvent = 'plastics-mold-history-event',
    metals3DModel = 'metals-3d-model',
    c3HardwareItems = 'c3-hardware-items',
    c3VendorHardwareData = 'c3-vendor-hardware-data',
    c3Product = 'c3-product',
    c3Order = 'c3-order',
    injectionMoldingOrder = 'injection-molding-order',
    c3CoolerModels = 'c3-cooler-models',
    plasticsProductCostModelVersion = 'plastics-product-cost-model-version',
    plasticsQuoteVersion = 'plastics-quote-version',
    plasticsHardwareItemShipment = 'plastics-hardware-item-shipment',
    metalsOrder = 'metals-order',
    obsessedEngineeringProduct = 'obsessed-engineering-product',
    obsessedEngineeringOrder = 'obsessed-engineering-order',
    obsessedEngineeringInvoice = 'oe-invoice',
    obsessedEngineeringComponentShipment = 'oe-component-shipment',
    directChat = 'direct-chat',
    suncastSnapshot = 'suncast-snapshot',
    capitalizationProject = 'capitalization-project',
    factoryMoveRequest = 'factory-move-request',
    metalsProductSetup = 'metals-product-setup',
    toolRoomMachine = 'tool-room-machine',
    employee = 'employee',
    employeeRecord = 'employee-record',
}
